/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import entityTypes from "functions/entityTypes";

const detailViewPathMap = {
    [entityTypes.DEPARTMENTS]: `/${entityTypes.DEPARTMENTS}/:pk`,
    [entityTypes.USERS]: `/${entityTypes.USERS}/:pk`,
    [entityTypes.TASK_TEMPLATES]: `/${entityTypes.TASK_TEMPLATES}/:pk`,
    [entityTypes.BUG_TEMPLATES]: `/${entityTypes.BUG_TEMPLATES}/:pk`,
    [entityTypes.PUBLISHED_FILE_TYPES]: `/${entityTypes.PUBLISHED_FILE_TYPES}/:pk`,

    [entityTypes.PROJECTS]: "/project/:prk",
    [entityTypes.SERIES]: `/project/:prk/${entityTypes.SERIES}/:pk`,
    [entityTypes.EPISODES]: `/project/:prk/${entityTypes.EPISODES}/:pk`,
    [entityTypes.SCENES]: `/project/:prk/${entityTypes.SCENES}/:pk`,
    [entityTypes.ASSETS]: `/project/:prk/${entityTypes.ASSETS}/:pk`,
    [entityTypes.TASKS]: `/project/:prk/${entityTypes.TASKS}/:pk`,
    [entityTypes.NOTES]: `/project/:prk/${entityTypes.NOTES}/:pk`,
    [entityTypes.VERSIONS]: `/project/:prk/${entityTypes.VERSIONS}/:pk`,
    [entityTypes.BUGS]: `/project/:prk/${entityTypes.BUGS}/:pk`,
    [entityTypes.ASSET_INSTANCES]: `/project/:prk/${entityTypes.ASSET_INSTANCES}/:pk`,
    [entityTypes.PUBLISHED_FILES]: `/project/:prk/${entityTypes.PUBLISHED_FILES}/:pk`,
};

const tablePathMap = {
    [entityTypes.DEPARTMENTS]: `/${entityTypes.DEPARTMENTS}/`,
    [entityTypes.GROUPS]: `/${entityTypes.GROUPS}/`,
    [entityTypes.STATUSES]: `/${entityTypes.STATUSES}/`,
    [entityTypes.TAGS]: `/${entityTypes.TAGS}/`,
    [entityTypes.STATUS_TYPES]: `/${entityTypes.STATUS_TYPES}/`,
    [entityTypes.STATUS_CONFIGS]: `/${entityTypes.STATUS_CONFIGS}/`,
    [entityTypes.PIPELINE_STEPS]: `/${entityTypes.PIPELINE_STEPS}/`,
    [entityTypes.ASSET_TYPES]: `/${entityTypes.ASSET_TYPES}/`,
    [entityTypes.ACTIVITY]: `/${entityTypes.ACTIVITY}/`,
    [entityTypes.TASK_TEMPLATES]: `/${entityTypes.TASK_TEMPLATES}/`,
    [entityTypes.BUG_TEMPLATES]: `/${entityTypes.BUG_TEMPLATES}/`,
    [entityTypes.PUBLISHED_FILE_TYPES]: `/${entityTypes.PUBLISHED_FILE_TYPES}/`,
    [entityTypes.FIELDS]: `/${entityTypes.FIELDS}/`,
    [entityTypes.USERS]: `/${entityTypes.USERS}/`,
};

const pagesMap = {
    permissions: "/permissions/",
    inbox: "/inbox/",
    site_preferences: "/site_preferences/",
    my_tasks: "/my_tasks/",
    projects: "/projects/",
    webhooks: "/webhooks/",
    menu_items: "/menu_items/",
};

const globalRoutesMap = {
    embedded: "/embedded",
    review_version_details: "/review_version_details/",
    "404_not_found": "/404_not_found/",
    "403_forbidden": "/403_forbidden/",
};

const path = {
    detailViews: detailViewPathMap,
    tables: tablePathMap,
    pages: { ...pagesMap, ...globalRoutesMap },
};

export default path;
